// https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};



if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();


let qtyMinus, qtyPlus, qtyMin, qtyMax;

// absolute addition
const thisUpdatesValues = this.classList.contains('product-quantity--adjust-values');
function updateRelatedValues(e, newQuantity, currency) {
	const singleTokenValue = e.target.closest('.price-wrapper').getAttribute('data-single-tokens');
	const singleCostPrice = e.target.closest('.price-wrapper').getAttribute('data-single-price');
	const newTokenAmount = singleTokenValue * newQuantity;
	const newCost = singleCostPrice * newQuantity;
	e.target.closest('.card__text').querySelector('.token p').innerHTML = newTokenAmount;
	e.target.closest('.card__text').querySelector('.price-wrapper .price-highlight span').innerHTML = currency + Shopify.formatMoney(newCost, "{{amount}}").replace('.00','');
}

			const qty = this.querySelector('.qty-selector');
			if(qty) {
							qtyMinus = this.querySelector('.qty-minus'),
							qtyPlus = this.querySelector('.qty-plus'),
							qtyMin = qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
							qtyMax = qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 999;

				if ( parseInt(qty.value) - 1 < qtyMin ) {
					qtyMinus.classList.add('disabled');
				}
				if ( parseInt(qty.value) + 1 > qtyMax ) {
					qtyPlus.classList.add('disabled');
				}

				qtyMinus.addEventListener('click', (e)=>{
					e.preventDefault();
					if ( ! qtyMinus.classList.contains('disabled') ) {
						const currentQty = parseInt(qty.value);
						if ( currentQty - 1 >= qtyMin ) {
							qty.value = currentQty - 1;
							qtyPlus.classList.remove('disabled');
						} 
						if ( currentQty - 1 <= qtyMin ) {
							qtyMinus.classList.add('disabled');
						}
						if(thisUpdatesValues) {
							updateRelatedValues(e, qty.value, qty.dataset.currency);
						}
					}
				});

				qtyPlus.addEventListener('click', (e)=>{
					e.preventDefault();
					if ( ! qtyPlus.classList.contains('disabled') ) {
						const currentQty = parseInt(qty.value);
						if ( currentQty + 1 <= qtyMax ) {
							qty.value = currentQty + 1;
							qtyMinus.classList.remove('disabled');
						} 
						if ( currentQty + 1 >= qtyMax ) {
							qtyPlus.classList.add('disabled');
						}
						if(thisUpdatesValues) {
							updateRelatedValues(e, qty.value, qty.dataset.currency);
						}
					}
				});
			}

		}
		
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}